import { useState, useEffect } from 'react';
import axios from 'axios';
import { Link, useNavigate } from 'react-router-dom';
import lykio_logo from '../../multimedia/lykio_logo_transparent.png';
import { AVAILABLE_COUNTRIES, HOME_URL, SINGLE_TENANCY_REGISTER_URL, PUBLIC_URL_PREFIX, UBER_ADMIN_SETTINGS_URL, FRONTEND_LOGIN_URL,NOTIFICATION_SEVERITY_SUCCESS, NOTIFICATION_SEVERITY_WARNING, AxiosConfigNoAuth } from '../../Utils/Constants';
import t from "../../Utils/Translation";
import './RegisterScreen.css';
import Form from 'react-bootstrap/Form';
import Button from 'react-bootstrap/Button';
import FloatingLabel from "react-bootstrap/FloatingLabel";
import Autocomplete from '@mui/material/Autocomplete';
import TextField from '@mui/material/TextField';
import Checkbox from "@material-ui/core/Checkbox";
import FormControlLabel from "@material-ui/core/FormControlLabel";
import { notify, pleaseRefreshError } from '../../Utils/Notificator';
import Footer from './../common/Footer';


const SingleTenancyRegisterScreen = () => {
	const [ firstname, setFirstname ] = useState('');
	const [ lastname, setLastname ] = useState('');
	const [ email, setEmail ] = useState('');
	const [ country , setCountry ] = useState('');
	const [ availableCountries, setAvailableCountries ] = useState(AVAILABLE_COUNTRIES);
	const [ availableRoles, setAvailableRoles ] = useState(["Professional working with elders","Professionals supporting mindful activities in ageing","Adult user age 50+"])
	const [ description, setDescription ] = useState(availableRoles[0]);
	const [ password, setPassword ] = useState('');
	const [ confirmPassword, setConfirmPassword ] = useState('');
	const [authScreensLogo, setAuthScreensLogo] = useState();
	const [ checkedBox, setCheckedBox] = useState(false);

	const navigate = useNavigate();

	useEffect(async() => {
		const { data } = await axios.get(
			`${PUBLIC_URL_PREFIX}${UBER_ADMIN_SETTINGS_URL}`,
			AxiosConfigNoAuth()
		);
		data.uberSettings && setAuthScreensLogo(data.uberSettings.authScreensLogo);

		const storageAuthTokenValue = localStorage.getItem('authToken');
		if (storageAuthTokenValue) {
			navigate(FRONTEND_LOGIN_URL);
		}
	}, []);

	const registerHandler = async (e) => {
		e.preventDefault();
		if(password.length<6){
			notify({
				title: `${t('Password must at least 6 characters long!')}`,
				severity: NOTIFICATION_SEVERITY_WARNING,
				creationDate: ''
			});
		}else{
		if (password !== confirmPassword) {
			setPassword('');
			setConfirmPassword('');
			notify({
				title: `${t('Passwords do not match')}`,
				severity: NOTIFICATION_SEVERITY_WARNING,
				creationDate: ''
			});
		}else{
		if (!country) {
			notify({
				title: `${t('Please select your country.')}`,
				severity: NOTIFICATION_SEVERITY_WARNING,
				creationDate: ''
			});
		}else
		/*if (!checkedBox) {
			notify({
				title: `${t('Please check the box to register.')}`,
				severity: NOTIFICATION_SEVERITY_WARNING,
				creationDate: ''
			});
		}else*/{
			try {
				const { data } = await axios.post(
					SINGLE_TENANCY_REGISTER_URL,
					{ firstname, lastname, email, password, country, description, checkedBox },
					AxiosConfigNoAuth()
				);
				if (data.success) {
					notify({
						title: `${t('You have successfully registered. An activation email was sent to your email.')}`,
						severity: NOTIFICATION_SEVERITY_SUCCESS,
						creationDate: ''
					});
				}
				navigate(FRONTEND_LOGIN_URL);
			} catch (error) {
				notify(pleaseRefreshError);
			}
		}
		}
	}
	};

	const handleDescriptionChange = (e) => {
		setDescription(e.target.value);
	};	

	const handleChangeCheckBox = (e) => {
		setCheckedBox(e.target.checked);
		console.log("checkedBox:",checkedBox)
	}

	return (
		<div className="lykiocss-generic-background lykiocss-hide-footer" style={{height:'100%', overflow:'auto', display:'grid', placeItems:'center'}}>
			<div className="lykiocss-screen-center" style={{height:'auto'}}>
				<Form onSubmit={registerHandler} className="LykioForm lykiocss-white-background lykiocss-form-border lykiocss-form-size">
					<Link to={HOME_URL}>
						<div className="lykiocss-center">
							<img className="lykiocss-small-login-logo" src={authScreensLogo ? authScreensLogo : lykio_logo} alt="" />
						</div>
					</Link>
					<Form.Group className="mb-3" controlId="firstname">
						<Form.Label>{t("First name")}</Form.Label>
						<Form.Control required type="text" placeholder={t("Enter your first name")} 
						value={firstname}
						onChange={(e) => {
							setFirstname(e.target.value);
						}}/>
					</Form.Group>

					<Form.Group className="mb-3" controlId="lastname">
						<Form.Label>{t("Last name")}</Form.Label>
						<Form.Control required type="text" placeholder={t("Enter your last name")} 
						value={lastname}
						onChange={(e) => {
							setLastname(e.target.value);
						}}/>
					</Form.Group>

					<Form.Group className="mb-3" controlId="email">
						<Form.Label>{t("Email")}</Form.Label>
						<Form.Control required type="email" placeholder="name@example.com" 
						value={email}
						onChange={(e) => {
							setEmail(e.target.value);
						}}/>
					</Form.Group>

					<Form.Group className="mb-3" controlId="country" >
						<Form.Label>{t("Start typing to find your country")}</Form.Label>
						<Autocomplete
							disablePortal
							id="combo-box-chooseCountry"
							options={availableCountries}
							onChange={(event, value) => {
								setCountry(value ? value.item : undefined)
							}}
							renderInput={(params) => (
								<TextField {...params} label={country} onChange={(event) => {
								console.log(event.target.value)
								setCountry(event.target.value)
								}}	/>
							)}
							/>
					</Form.Group>

					<Form.Group className="mb-3" controlId="role" >
						<FloatingLabel controlId="floatingrole" label={t('Choose your role')}>
							<Form.Select onChange={handleDescriptionChange}>
									{availableRoles.map((role) => (
										<option key={role} value={role}>
											{role}
										</option>
									))}
							</Form.Select>
						</FloatingLabel>
					</Form.Group>				

					<Form.Group className="mb-3" controlId="password">
						<Form.Label>{t("Password")}</Form.Label>
						<Form.Control required type="password" placeholder={t("Enter password (6 characters or more)")} 
						value={password}
						onChange={(e) => {
							setPassword(e.target.value);
						}}/>
					</Form.Group>

					<Form.Group className="mb-3" controlId="confirmpassword">
						<Form.Label>{t("Confirm Password")}</Form.Label>
						<Form.Control required type="password" placeholder={t("Confirm your password")} 
						value={confirmPassword}
						onChange={(e) => {
							setConfirmPassword(e.target.value);
						}}/>
					</Form.Group>
					
					<Form.Group className="mb-3" controlId="checkPhrase" style={{maxWidth:'27rem'}}>
						<FormControlLabel
							control={<Checkbox style={{marginTop:'-25px'}} color="primary" checkedBox={checkedBox} onChange={handleChangeCheckBox} />}
							label={t("I'm committed to combating isolation and loneliness in older people through Mindful Ageing.")}
						/>
					</Form.Group>

					<Form.Group className="mb-3">
						<Button variant="primary" type="submit" className="float-end" size="sm">
						{t("Register")}
						</Button>
					</Form.Group>
				</Form>
			</div>
			<div >
			<Footer />
			</div>
		</div>
	);
};

export default SingleTenancyRegisterScreen;
